module.exports = __webpack_public_path__ + "static/media/asv_bloc3-min.00653bde.png";